import { useNavigate } from "react-router-dom";
import { AuthContext } from "../Firebase/AuthProvider";
import { Fragment, useContext, useState, useEffect } from "react";
import logo from "../assets/only_name_LOGO.svg";
import uploadFabricIcon from "../assets/icon-upload-fabric.png";
import uploadFabricTypeIcon from "../assets/icon-upload-fabric-type.png";
import suitIcon from "../assets/icon-suit.png";
import buttonIcon from "../assets/icon-button.png";
import embroideryStyleIcon from "../assets/icon-embroidery-style.png";
import singleEmbroideryIcon from "../assets/icon-single-embroidery.png";
import embroideryCollectionIcon from "../assets/icon-embroidery-collection.png";
import { db } from "../firebase";

// Sidebar ko sections me dikhate hain — indices Admin.js ke T array ke hain.
// Navigation logic same rehta hai (k hi route banta hai), sirf visual grouping.
const MENU_GROUPS = [
    { label: "Operations", items: [0, 19, 27, 21, 31, 20, 1, 24, 16, 17, 18, 30, 28, 29] },
    { label: "Catalog", items: [2, 3, 4, 5, 6, 7, 26, 8, 25, 9, 10, 11] },
    { label: "Embroidery", items: [12, 13, 14] },
    { label: "System", items: [15, 23, 22] },
];

function Left_panel({set, T, current}) {

    const { running, user, userSignOut} = useContext(AuthContext);
    const [mobileOpen, setMobileOpen] = useState(false);
    const [unreadCount, setUnreadCount] = useState(0);
    const [pendingCallCount, setPendingCallCount] = useState(0);
    const [pendingSupportCount, setPendingSupportCount] = useState(0);
    const [newDesignCount, setNewDesignCount] = useState(0);
    const [pendingBusinessCount, setPendingBusinessCount] = useState(0);
    const [careCount, setCareCount] = useState(0);

    const navigate = useNavigate();

    useEffect(() => {
        if (!user) return;
        
        // Listen to unread notifications count in real-time
        const unsubscribe = db.collection("Notifications")
            .where("read", "==", false)
            .onSnapshot(snapshot => {
                setUnreadCount(snapshot.size);
            }, error => {
                console.error("Error listening to notifications: ", error);
            });

        return () => unsubscribe();
    }, [user]);

    useEffect(() => {
        if (!user) return;

        const unsubscribe = db.collection("CallSchedules")
            .where("status", "==", "pending")
            .onSnapshot(snapshot => {
                setPendingCallCount(snapshot.size);
            }, error => {
                console.error("Error listening to call schedules: ", error);
            });

        return () => unsubscribe();
    }, [user]);

    useEffect(() => {
        if (!user) return;

        const stopCare = db.collection("Alterations")
            .where("status", "in", ["requested", "bill_sent"])
            .onSnapshot(snapshot => setCareCount(snapshot.size), () => setCareCount(0));

        const unsubscribe = db.collection("Businesses")
            .where("status", "==", "pending")
            .onSnapshot(snapshot => setPendingBusinessCount(snapshot.size), () => setPendingBusinessCount(0));

        return () => { unsubscribe(); stopCare(); };
    }, [user]);

    useEffect(() => {
        if (!user) return;

        const unsubscribe = db.collection("SupportRequests")
            .where("status", "==", "pending")
            .onSnapshot(snapshot => {
                setPendingSupportCount(snapshot.size);
            }, error => {
                console.error("Error listening to support requests: ", error);
            });

        return () => unsubscribe();
    }, [user]);

    useEffect(() => {
        if (!user) return;

        const unsubscribe = db.collection("queries")
            .where("formType", "==", "design_photo")
            .onSnapshot(snapshot => {
                const open = snapshot.docs.filter((doc) => doc.data().status !== "replied").length;
                setNewDesignCount(open);
            }, error => {
                console.error("Error listening to design requests: ", error);
            });

        return () => unsubscribe();
    }, [user]);

    const getMenuIcon = (label) => {
        const text = (label || "").toLowerCase();
        if (text.includes("upload button")) return <img src={buttonIcon} alt="" className="left-menu-icon-img" />;
        if (text.includes("view product")) {
            return (
                <span className="left-menu-icon-combo">
                    <img src={suitIcon} alt="" className="left-menu-icon-img" />
                    <span className="left-menu-view-mark" aria-hidden="true">◉</span>
                </span>
            );
        }
        if (text.includes("upload product")) return <img src={suitIcon} alt="" className="left-menu-icon-img" />;
        if (text.includes("edit outfit")) {
            return (
                <span className="left-menu-icon-combo">
                    <img src={uploadFabricTypeIcon} alt="" className="left-menu-icon-img" />
                    <span className="left-menu-edit-mark" aria-hidden="true">✎</span>
                </span>
            );
        }
        if (text.includes("upload outfit")) return <img src={uploadFabricTypeIcon} alt="" className="left-menu-icon-img" />;
        if (text.includes("edit fabric")) {
            return (
                <span className="left-menu-icon-combo">
                    <img src={uploadFabricIcon} alt="" className="left-menu-icon-img" />
                    <span className="left-menu-edit-mark" aria-hidden="true">✎</span>
                </span>
            );
        }
        if (text.includes("upload fabric")) return <img src={uploadFabricIcon} alt="" className="left-menu-icon-img" />;
        if (text.includes("embroidery style")) return <img src={embroideryStyleIcon} alt="" className="left-menu-icon-img" />;
        if (text.includes("single embroidery")) return <img src={singleEmbroideryIcon} alt="" className="left-menu-icon-img" />;
        if (text.includes("embroidery collection")) return <img src={embroideryCollectionIcon} alt="" className="left-menu-icon-img" />;
        if (text.includes("fabric purchase")) return "🧵";
        if (text.includes("call schedule")) return "☎";
        if (text.includes("design photo")) return "📷";
        if (text.includes("style pages")) return "🗂";
        if (text.includes("upload uniform")) return "👔";
        if (text.includes("uniform orders")) return "👕";
        if (text.includes("notification")) return "🔔";
        if (text.includes("support")) return "🎧";
        if (text.includes("coupon")) return "🎟";
        if (text.includes("business")) return "💼";
        if (text === "care") return "🪡";
        if (text.includes("review")) return "⭐";
        if (text.includes("campus")) return "🎓";
        if (text.includes("packing")) return "📦";
        if (text.includes("order")) return "🧾";
        if (text.includes("fabric")) return "🧵";
        if (text.includes("brand")) return "🏷";
        if (text.includes("preset")) return "📐";
        if (text.includes("button")) return "🔘";
        if (text.includes("tuxedo")) return "🤵";
        if (text.includes("piping")) return "📏";
        if (text.includes("embroidery")) return "🪡";
        if (text.includes("analytics")) return "📈";
        if (text.includes("dashboard")) return "📊";
        if (text.includes("logout")) return "⎋";
        if (text.includes("login")) return "🔐";
        return "•";
    };

    

    return ( <>
    <button
        type="button"
        className="nav-fab"
        aria-label={mobileOpen ? "Close menu" : "Open menu"}
        onClick={() => setMobileOpen((o) => !o)}
    >
        {mobileOpen ? "✕" : "☰"}
    </button>
    {mobileOpen && <div className="nav-overlay" onClick={() => setMobileOpen(false)} />}
    <div className={`left ${mobileOpen ? "left--open" : ""}`}>
        <div className="left-welcome-panel">
            <div className="left-welcome-text">Welcome to</div>
            <img src={logo} alt="Maviinci Logo" className="left-welcome-logo" />
        </div>
        

        {(user && !running) ? <ul className="left-menu-list">
            {MENU_GROUPS.map((g) => (<Fragment key={g.label}>
            <li className="left-menu-group">{g.label}</li>
            {g.items.filter((k) => T[k] !== undefined).map((k) => {
                const v = T[k];
                return(<li className={`left-menu-item ${current === k ? "left-menu-item-active" : ""}`}
                key={v}
                type="button"
                    onClick={()=>{
                        setMobileOpen(false);
                        // Bound to the label, not the position: this used to
                        // be `k === T.length - 1`, so appending any tab after
                        // Logout turned that new tab into the logout button.
                        if (v === "Logout") {
                            userSignOut();
                            navigate("/");
                        } else {
                            navigate(`/admin/${k}`);
                        }
                    }}
                >
                    <span className="left-menu-icon">{getMenuIcon(v)}</span>
                    <span className="left-menu-text">
                        {v}
                        {v === "Notifications" && unreadCount > 0 && (
                            <span className="badge rounded-pill bg-danger" style={{
                                marginLeft: '10px',
                                fontSize: '0.72rem',
                                fontWeight: 700,
                                padding: '3px 8px',
                                verticalAlign: 'middle',
                                boxShadow: '0 2px 6px rgba(239, 68, 68, 0.4)'
                            }}>
                                {unreadCount}
                            </span>
                        )}
                        {v === "Call Schedule" && pendingCallCount > 0 && (
                            <span className="badge rounded-pill bg-warning text-dark" style={{
                                marginLeft: '10px',
                                fontSize: '0.72rem',
                                fontWeight: 700,
                                padding: '3px 8px',
                                verticalAlign: 'middle',
                                boxShadow: '0 2px 6px rgba(245, 158, 11, 0.35)'
                            }}>
                                {pendingCallCount}
                            </span>
                        )}
                        {v === "Design Photos" && newDesignCount > 0 && (
                            <span className="badge rounded-pill bg-warning text-dark" style={{
                                marginLeft: '10px',
                                fontSize: '0.72rem',
                                fontWeight: 700,
                                padding: '3px 8px',
                                verticalAlign: 'middle',
                                boxShadow: '0 2px 6px rgba(245, 158, 11, 0.35)'
                            }}>
                                {newDesignCount}
                            </span>
                        )}
                        {v === "Care" && careCount > 0 && (
                            <span className="badge rounded-pill bg-danger" style={{
                                marginLeft: '10px',
                                fontSize: '0.72rem',
                                fontWeight: 700,
                                padding: '3px 8px',
                                verticalAlign: 'middle',
                                boxShadow: '0 2px 6px rgba(239, 68, 68, 0.4)'
                            }}>
                                {careCount}
                            </span>
                        )}
                        {v === "Business Accounts" && pendingBusinessCount > 0 && (
                            <span className="badge rounded-pill bg-warning text-dark" style={{
                                marginLeft: '10px',
                                fontSize: '0.72rem',
                                fontWeight: 700,
                                padding: '3px 8px',
                                verticalAlign: 'middle',
                                boxShadow: '0 2px 6px rgba(245, 158, 11, 0.35)'
                            }}>
                                {pendingBusinessCount}
                            </span>
                        )}
                        {v === "Support" && pendingSupportCount > 0 && (
                            <span className="badge rounded-pill bg-danger" style={{
                                marginLeft: '10px',
                                fontSize: '0.72rem',
                                fontWeight: 700,
                                padding: '3px 8px',
                                verticalAlign: 'middle',
                                boxShadow: '0 2px 6px rgba(239, 68, 68, 0.4)'
                            }}>
                                {pendingSupportCount}
                            </span>
                        )}
                    </span>
                </li>)
            })}
            </Fragment>))}
        </ul>
        : <ul className="left-menu-list">
            <li className="left-menu-item"
                onClick={()=>{
                    setMobileOpen(false);
                    navigate("/login")
                }}
                type="button"
            >
                <span className="left-menu-icon">{getMenuIcon("login")}</span>
                <span className="left-menu-text">Login</span>
            </li>
        </ul>
    }
    </div>
    </> );
}

export default Left_panel;